<template>
	<div>
		<h3 v-if="!$root.isMobile()">LISTA DOS DOCUMENTOS REQUERIDOS (POR FAVOR, ANEXE)</h3>

		<h3 v-if="$root.isMobile()">LISTA DOS DOCUMENTOS REQUERIDOS (POR FAVOR, ANEXE OU TIRE UMA FOTOGRAFIA)</h3>

		<files-component
			ref="cpf"
			:fileType="'cpf'"
			:files="cpf"
			:required="true"
			:uploadedFiles="$store.state.form.uploadedDocuments.cpf"
			label="Cópia do RG, CPF, RNE ou passaporte de todos os administradores, sócios com 25% ou mais de participação na empresa e dos representantes que assinam o contrato"
			sub-label="caso o sócio seja uma pessoa jurídica, cópia do Contrato Social e cópia do RG, RNE ou passaporte e CPF de todos os sócios com mais de 25% de participação no sócio pessoa jurídica." />

		<files-component
			ref="addressPartners"
			:fileType="'address_partners'"
			:files="addressPartners"
			:required="true"
			:uploadedFiles="$store.state.form.uploadedDocuments.addressPartners"
			label="Cópia de documento que ateste o endereço das pessoas físicas constantes no contrato social da empresa (sócios e administradores)"
			sub-label="conta de serviço público ou atestado de entidade competente: conta de água, luz, telefone, etc." />

		<files-component
			ref="cnpj"
			:fileType="'cnpj'"
			:files="cnpj"
			:required="true"
			:uploadedFiles="$store.state.form.uploadedDocuments.cnpj"
			label="Cópia do cartão CNPJ" />

		<files-component
			ref="address"
			:fileType="'address'"
			:files="address"
			:uploadedFiles="$store.state.form.uploadedDocuments.address"
			label="Cópia do documento que ateste o endereço registrado"
			sub-label="conta de serviço público ou atestado de entidade competente: conta de água, luz, telefone, etc." />

		<files-component
			v-if="!$store.state.form.establishment.sameAddress"
			ref="secondAddress"
			:fileType="'second_address'"
			:files="secondAddress"
			:required="true"
			:uploadedFiles="$store.state.form.uploadedDocuments.secondAddress"
			label="Cópia do documento que ateste o endereço físico"
			sub-label="conta de serviço público ou atestado de entidade competente: conta de água, luz, telefone, etc." />

		<files-component
			ref="contract"
			:fileType="'contract'"
			:files="contract"
			:required="true"
			:uploadedFiles="$store.state.form.uploadedDocuments.contract"
			label="Cópia do contrato social"
			sub-label="deve constar no documento anexado o % de propriedade dos indivíduos ou entidades que detenham mais de 25% de participação" />

		<files-component
			v-if="$store.state.form.pci.integration.pci > 0"
			ref="pci"
			:fileType="'pci'"
			:files="pci"
			:uploadedFiles="$store.state.form.uploadedDocuments.pci"
			label="Cópia do certificado de conformidade PCI" />

		<files-component
			ref="socialContract"
			:fileType="'social_contract'"
			:files="socialContract"
			:uploadedFiles="$store.state.form.uploadedDocuments.socialContract"
			label="Cópia da última alteração do contrato social, estatuto ou ata" />

		<files-component
			ref="representative"
			:fileType="'representative'"
			:files="representative"
			:uploadedFiles="$store.state.form.uploadedDocuments.representative"
			label="Documento que comprove a representação legal" />

		<confirm-modal-component type="document" />
	</div>
</template>

<script>
import FilesComponent from "@/components/Form/Inputs/FilesComponent";
import ConfirmModalComponent from "@/components/Form/ConfirmModalComponent";

export default {
	name: "DocumentsFormComponent",
	components: {
		FilesComponent,
		ConfirmModalComponent,
	},
	props: ["validationTrigger"],
	mounted() {
		this.$store.dispatch("updateStep", this.step);
		this.$emit("setReadyToSubmit", this.isValid);
	},
	watch: {
		isValid(value) {
			this.$emit("setReadyToSubmit", value);
		},
		validationTrigger() {
			this.$emit("setReadyToSubmit", this.isValid);
		},
	},
	computed: {
		isValid() {
			let documents = this.$store.state.form.documents;
			let uploadedDocuments = this.$store.state.form.uploadedDocuments;
			let establishment = this.$store.state.form.establishment;

			return (
				(documents.cpf.length || uploadedDocuments.cpf.length) &&
				(documents.addressPartners.length || uploadedDocuments.addressPartners.length) &&
				(documents.cnpj.length || uploadedDocuments.cnpj.length) &&
				(establishment.sameAddress ||
					documents.secondAddress.length ||
					uploadedDocuments.secondAddress.length) &&
				(documents.contract.length || uploadedDocuments.contract.length)
			);
		},
		cpf: {
			get() {
				return this.$store.state.form.documents.cpf;
			},
			set(value) {
				this.$store.commit("setDocuments", {
					form: "cpf",
					value,
				});
			},
		},
		addressPartners: {
			get() {
				return this.$store.state.form.documents.addressPartners;
			},
			set(value) {
				this.$store.commit("setDocuments", {
					form: "addressPartners",
					value,
				});
			},
		},
		cnpj: {
			get() {
				return this.$store.state.form.documents.cnpj;
			},
			set(value) {
				this.$store.commit("setDocuments", {
					form: "cnpj",
					value,
				});
			},
		},
		address: {
			get() {
				return this.$store.state.form.documents.address;
			},
			set(value) {
				this.$store.commit("setDocuments", {
					form: "address",
					value,
				});
			},
		},
		secondAddress: {
			get() {
				return this.$store.state.form.documents.secondAddress;
			},
			set(value) {
				this.$store.commit("setDocuments", {
					form: "secondAddress",
					value,
				});
			},
		},
		contract: {
			get() {
				return this.$store.state.form.documents.contract;
			},
			set(value) {
				this.$store.commit("setDocuments", {
					form: "contract",
					value,
				});
			},
		},
		socialContract: {
			get() {
				return this.$store.state.form.documents.socialContract;
			},
			set(value) {
				this.$store.commit("setDocuments", {
					form: "socialContract",
					value,
				});
			},
		},
		pci: {
			get() {
				return this.$store.state.form.documents.pci;
			},
			set(value) {
				this.$store.commit("setDocuments", {
					form: "pci",
					value,
				});
			},
		},
		representative: {
			get() {
				return this.$store.state.form.documents.representative;
			},
			set(value) {
				this.$store.commit("setDocuments", {
					form: "representative",
					value,
				});
			},
		},
		step() {
			return this.$store.state.form.step;
		},
	},
};
</script>
